module.exports = __webpack_public_path__ + "static/media/two-country-divider.70efdf68.svg";